import { ChangeEvent, useEffect, useRef, useState } from "react";
import AdminNavBar from "./AdminNavBar";
import UnitsNavBar from "./UnitsNavBar";

const EditUnit = () => {
	interface Unit {
		id: number;
		unit: string;
		active: boolean;
		paid: boolean;
	}

	var unitRef = useRef<HTMLSelectElement>(null)

	const [units, setUnits] = useState<Unit[]>([])
	const [isVisible, setIsVisible] = useState(false)
	const [selectedUnit, setSelectedUnit] = useState<Unit>({ id: 0, unit: "", active: false, paid: false })
	const [unitName,setUnitName] = useState("")
	const [msg, setMsg] = useState("")
	
	const getUnits = async () => {
		const response = await fetch(process.env.REACT_APP_API+"/api/units")
		if (response) {
			const units = await response.json()
			setUnits(units)
		}
	}

	const editUnit = async () => {
		if (unitName !== "") {
			const payload = {id: selectedUnit.id, unit: unitName, paid: selectedUnit.paid}
			const response = await fetch(process.env.REACT_APP_API+"/api/unit",{
				method: "PUT",
				body: JSON.stringify(payload)
			})
			const msg = await response.json()
			if (unitRef && unitRef.current ) {
				unitRef.current.value = ""
				setUnitName("")
				setIsVisible(false)
				getUnits()
			}
			setMsg(msg.msg)
		} else {
			setMsg("Unit name cannot be empty")
		}
	}
	
	const handleSelectChange = async () => {
		if (unitRef && unitRef.current) {
			const id = unitRef.current.value;
			const response = await fetch(process.env.REACT_APP_API+"/api/unit?id=" + id);
			const unit = await response.json()
			setSelectedUnit(unit)
			setIsVisible(true)
			setMsg("")
		}
	}

	const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
		setSelectedUnit({...selectedUnit, paid: event.target.checked})
	}
	
	const handleUnitChange = (event: ChangeEvent<HTMLInputElement>) => {
		setUnitName(event.target.value)
	}

	
	useEffect(() => {
		getUnits()
		if (selectedUnit && selectedUnit.id && selectedUnit.id > 0){
			setUnitName(selectedUnit.unit)
		}
	},[selectedUnit])
	return (
		<div className="resilire">
			<AdminNavBar />
			<UnitsNavBar />
			<label htmlFor="unit">Unit Name</label>
			<select id="units" onChange={handleSelectChange} ref={unitRef}>
				<option value=""></option>
				{units.map((unit) => (
					<option value={unit.id} key={unit.id}>{unit.unit}</option>
				))}
			</select>
			{isVisible &&
			 (
					<div className="resilire">
						<label htmlFor="unit">Unit Name</label>
						<input id="unit" name="unit" value={unitName} onChange={handleUnitChange}></input>
						<label htmlFor="paid">Is Unit Paid?</label>
						<div>
							<input id="paid" type="checkbox" value="true" checked={selectedUnit.paid} onChange={handleCheckboxChange}  />
							<label htmlFor="paid"> Yes</label>
						</div>
						<button name="submit" onClick={editUnit}>Update</button>
					</div>
				)
			}
			{msg && (
				<div className="resilire">
					{msg}
				</div>
			)}
		</div>
	)
};
export default EditUnit;
